const baseUrl = "/settings/adyen";
export default {
    /**
     *
     * @returns promise
     * Return list of user notifications
     */
    getSettings() {
        return ApiClient.get(baseUrl);
    },

    /**
     *
     * @param shouldUpdateSettings
     * @param adyenForm
     * Send post or put based on params
     */
    saveSettings(shouldUpdateSettings, adyenForm) {
        return new Promise((resolve, reject) => {
            const request = shouldUpdateSettings ? ApiClient.put(baseUrl, {}, adyenForm) : ApiClient.post(baseUrl, {}, adyenForm);
            request.then(response => resolve(response.data)).catch(err => reject(err.response.data.error));
        });
    },
};